import { render, staticRenderFns } from "./preservationPay.vue?vue&type=template&id=fb912732&scoped=true&"
import script from "./preservationPay.vue?vue&type=script&lang=js&"
export * from "./preservationPay.vue?vue&type=script&lang=js&"
import style0 from "./preservationPay.vue?vue&type=style&index=0&id=fb912732&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb912732",
  null
  
)

export default component.exports